import { ReviewSample } from "@/components/company/reviews/review-sample"
import type { ReviewWithData } from "@/helpers/company/review-utils"
import type { VerdictOutput } from "@/types/models"

import Markdown from "../markdown"

export function VerdictSection({
  verdictOutput,
  topReviews,
}: {
  verdictOutput: VerdictOutput | null
  topReviews: ReviewWithData[]
}) {
  if (!verdictOutput) {
    return <p className="text-muted-foreground">Analysis coming soon.</p>
  }

  return (
    <div className="space-y-6">
      <Markdown className="font-serif leading-relaxed">
        {verdictOutput.narrative}
      </Markdown>
      {verdictOutput.verdict && (
        <p className="font-serif leading-relaxed">{verdictOutput.verdict}</p>
      )}

      {topReviews.length > 0 && (
        <div className="border-t-2 pt-6">
          <h3 className="wb-h6 mb-4">3 Stories That Stood Out</h3>
          <ReviewSample reviews={topReviews} shouldHideTags />
        </div>
      )}
    </div>
  )
}
